import { render, staticRenderFns } from "./CardUseSoilChart.vue?vue&type=template&id=36f5b894&scoped=true"
import script from "./CardUseSoilChart.vue?vue&type=script&lang=js"
export * from "./CardUseSoilChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5b894",
  null
  
)

export default component.exports